import { render } from "./particlesBottomRight.vue?vue&type=template&id=e60f8554&scoped=true"
import script from "./particlesBottomRight.vue?vue&type=script&lang=js"
export * from "./particlesBottomRight.vue?vue&type=script&lang=js"

import "./particlesBottomRight.vue?vue&type=style&index=0&id=e60f8554&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e60f8554"]])

export default __exports__